export default __webpack_public_path__ + "static/media/carbon-tax.23e7574a.png";